import PropTypes from 'prop-types';
import './speakers.css';
import Logo from './logo.png';

export const Speaker = ({ speaker, handleClick }) => {
  console.log(speaker);
  return (
    <div className="snn-speaker-card" onClick={handleClick}>
      <div className="snn-speakers-card-img">
        <img src={speaker.img} alt={speaker.name} />
        <div className="snn-speaker-shield">
          <img src={Logo} />
        </div>
      </div>
        <div
            className='snn-speakers-card-description'
        >
            <h2>{speaker.name}</h2>
            <div className="logo-university">
                <img src={speaker.logo} alt={speaker.name}/>
            </div>
            <p>{speaker.affiliation}</p>
        </div>
    </div>
  );
};

Speaker.propTypes = {
    speaker: PropTypes.any,
    handleClick: PropTypes.func,
};
